import firebase from 'firebase';

//DO NOT FORGET TO CHANGE rules TO != from === after EVERYTHING IS DONE
// Initialize Firebase
var config = {
    apiKey: "AIzaSyD2JBLTkaSt5FA6NlYCYdEA6jiUju57dRY",
    authDomain: "tinqerapps.firebaseapp.com",
    databaseURL: "https://tinqerapps.firebaseio.com",
    projectId: "tinqerapps",
    storageBucket: "tinqerapps.appspot.com",
    messagingSenderId: "849477932944"
};
// export var firebaseApp = firebase.initializeApp(config);
var firebaseApp = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
//console.log(firebaseApp.options);
export default firebaseApp;


// WEBPACK FOOTER //
// ./src/Firebase/Firebase.js